import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const advancedTrackingState = atom<boolean>({
  key: 'advancedTrackingState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
